import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'psm-date-time-picker',
    templateUrl: 'dateTimePicker.component.html',
    styleUrls: ['dateTimePicker.component.scss']
})

export class DateTimePickerComponent {

    public bsConfig = {};

    @Input()
    public showTimePick: boolean = false;

    constructor(private translate: TranslateService) {
        this.bsConfig = Object.assign({}, {
            locale: this.translate.currentLang
        });
    }

    @Input()
    public date: Date;

    @Output()
    public dateChange: EventEmitter<Date> = new EventEmitter();

    @Input()
    public min: Date;

    @Input()
    public max: Date;

    public is24() {
        return this.translate.instant('time.is24');
    }

    public onDateChange(date: Date) {
        this.date.setMilliseconds(0);
        this.date.setSeconds(0);
        if (!this.showTimePick) {
            this.date.setHours(0);
            this.date.setMinutes(0);
        }

        if (date.getTime() !== this.date.getTime()) {
            this.date = date;
            this.dateChange.emit(this.date);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/common/dateTimePicker/dateTimePicker.component.ts